const dig = (object, keys: string[]) => {
  let value = object
  keys.forEach(key => {
    value = value ? value[key] : null
  })
  return value
}

export default dig
